import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { compile } from '~/apps/ninesegsAnalyzer/routes/paths'
import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'
import { useLogEvent } from '~/hooks/useLogEvent'

import { useBrandAccountId } from '../hooks/useBrandAccountId'
import { useCreateDocumentReportMutation } from '../hooks/useCreateDocumentReportMutation'

export const CreateButton = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const brandAccountId = useBrandAccountId()
  const logEvent = useLogEvent()
  const createDocumentReportMutation = useCreateDocumentReportMutation({
    onSuccess: (documentReportId) => {
      navigate(
        compile('documentReportEdit', { brandAccountId, documentReportId }),
      )
      logEvent('Create document')
    },
  })

  const handleClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    createDocumentReportMutation.mutate()
  }, [createDocumentReportMutation])

  return (
    <StyledButton
      buttonStyle="success"
      disabled={createDocumentReportMutation.isPending}
      fillMode="outline"
      icon="add"
      onClick={handleClick}
    >
      {t('create_new_1')}
    </StyledButton>
  )
}
